<script>

import CountyMap from "../CountyMap";
const axios = require('axios').default;

export default {
  name: 'PartnerSearch',
  mixins: [axios],
  components: {CountyMap},
  data() {
    return {
      counties: {},
      filter: "",
      displayResults: false,
      results: [],
      highlightedCounty: null
    };
  },
  created() {
    this.getCounties()
  },
  methods: {
    getCounties() {
      axios.get('/counties').then((response) => {
        this.counties = response.data
      })
    },
    getCountyNames(){
      return Object.values(this.counties)
    },
    search(value = null) {
      this.highlightedCounty = null

      if (value) {
        this.filter = value
      }
      axios.get('/partners?search=' + this.filter).then((response) => {
        this.results = response.data.results || []
        this.displayResults = true
        this.highlightedCounty = this.filter
      })
    },
    countyWasClicked(countyInfo){
      this.search(countyInfo.properties.name);
    }
  },
};

</script>

<template>
  <div class="w-full flex flex-col lg:flex-row px-8 py-20 bg-gray-100 text-navy-default gap-20">
    <div class="w-full flex-1">
      <h2 class="text-3xl font-semibold {{displayResults === true ? 'w-5/12' : ''}}">Search Partners by Location</h2>
      <div class="h-1 w-1/5 bg-gold-default my-4"></div>
      <form @submit.prevent="search()" method="post" class="mb-6 {{displayResults === true ? 'w-1/2' : ''}}">
        <div class="flex flex-col md:flex-row ">
          <div class="flex-grow">
            <div class="h-12 flex flex-row bg-white rounded-full">
              <input type="text" v-model="filter" class="h-12 rounded-l-full my-auto py-2 px-4 w-full"
                     placeholder="County or Zipcode">
              <button type="submit"
                      class="bg-gold-default hover:bg-gold-darker text-white font-semibold py-2 px-4 rounded-full">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div>
        <county-map :counties="getCountyNames()"
                    state="Iowa"
                    :highlighted-county="highlightedCounty"
                    :county-click-handler="countyWasClicked"></county-map>
      </div>

    </div>

    <!--Results-->
    <div class="flex-initial justify-center w-full lg:w-1/2 bg-white py-4 pl-4 pr-4 lg:pr-0 -mr-8">
      <div class="w-full tracking-wider">
        <div>
          <h3 class="text-xl font-semibold border-navy-default w-full border-b-2 border-navy-default pb-2 mb-2">
            Results
          </h3>
          <p class="text-sm" v-if="results.length !== 0"  v-show="displayResults">
            for {{
              filter
            }}
          </p>
        </div>
        <div class="flex flex-col w-full">
          <ul class="my-6 overflow-y-scroll max-h-96">
            <li v-for="(partner,id) in results"
                class="grid grid-cols-1 md:grid-cols-2 border-t-2 items-center py-4 gap-4 pr-4">
              <img :src="'/storage/' + partner.logo" class="w-full bg-cover" :alt="partner.name + ' logo'"/>
              <div>
                <a :href="`/partners/` + partner.id"
                   class="text-navy-default font-semibold pb-6 w-full text-lg">
                  {{ partner.name }}
                </a>
              </div>

            </li>
          </ul>

          <div class="p-4" v-if="results.length === 0">
            No partners found. Update your search parameters.
          </div>

          <div class="py-2">
            <a href="partners"
               class="text-white font-semibold shadow-sm bg-blue-default rounded-full py-4 px-4 lg:px-6 text-sm">View
              All Agencies</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>